<template>
    <div class="text-center">

        <v-progress-circular :rotate="360" :size="200" :width="24" :value="totalEncodingValue" color="#BDBDBD"
            class="mb-5">
            <h1 style="font-size: 2.5em; color: #616161;">{{ totalEncodingValue }}%</h1>
        </v-progress-circular>

        <v-col class="mb-3" v-if="!reference.rp_encoding">
            <v-btn icon :color="encodingUnit === 'MB' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                @click="changeEncodingUnit('M')">
                MB
            </v-btn>
            <v-btn icon :color="encodingUnit === 'GB' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                class="ml-1 mr-1" @click="changeEncodingUnit('G')">
                GB
            </v-btn>
            <v-btn icon :color="encodingUnit === 'TB' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                @click="changeEncodingUnit('T')">
                TB
            </v-btn>
        </v-col>

        <div class="statistics_sub">
            <h5 class="ml-2"  style="color:#999;">{{ formattedDate }}</h5>
            <!-- <h5 v-if="this.startTime" class="mb-2" style="color:#999">{{ this.startTime }} ~ {{ this.endTime }}</h5> -->
            <span>{{ $store.getters.t('기준 사용량') }} {{ totalEncodingUnit }} {{ encodingUnit }}</span>
            
        </div>

        <h4>{{ $store.getters.t('사용') }} {{ usedEncoding }} <strong>{{ encodingUnit }}</strong></h4>
        <!-- <h4 v-if="usedEncoding">사용 {{ usedEncoding }} <strong>{{ encodingUnit }}</strong></h4>
        <h4 v-else class="statistics_sub"><span class="loading-icon mt-2 mr-2"></span></h4> -->
    </div>
</template>

<script>
import StatisticsApi from "@/api/statistics/StatisticsApi";

export default {
    name: 'EncodingComponent',
    props: ['reference', 'units', 'formattedDate'],
    data() {
        return {
            OriginalEncodingUsage: 0,
            usedEncoding: 0,
            totalEncodingValue: '',
            startTime: '',
            endTime: '',
            totalEncoding: this.reference && this.reference.rp_encoding ? this.reference.rp_encoding : 1000,
            encodingUnit: this.reference && this.reference.rp_unit ? this.reference.rp_unit : 'GB',
            dates: [],
            isDatePickerVisible: false,
        };
    },
    // mounted() {
    //     // this.encodingUnit = this.reference && this.reference.rp_unit ? this.reference.rp_unit : 'MB';
    //     // this.getEncodingUsageData();
    // },
    methods: {
        // async getEncodingUsageData() {
        //     const response = await StatisticsApi.encodingApi();
        //     if (response.encoding_usage) {
        //         this.startTime = response.date.start_time;
        //         this.endTime = response.date.end_time;

        //         this.OriginalEncodingUsage = parseFloat(response.encoding_usage).toFixed(2);    //   730032
        //         this.usedEncoding = this.OriginalEncodingUsage;                                             
        //         this.unitAutoChange();
        //     } else {
        //         this.usedEncoding = "0.00";
        //         this.startTime = response.date.start_time;
        //         this.endTime = response.date.end_time;
        //         this.totalEncodingValue = 0;
        //     }
        // },
        async getEncodingUsageData() {
            const [start, end] = this.formattedDate.split('~');
            this.startTime = start.trim()
            this.endTime = end.trim()
            
            const params = {
                startTime: this.startTime,
                endTime: this.endTime
            }
            const response = await StatisticsApi.encodingDatePickerApi(params);
            if(response){
                this.OriginalEncodingUsage = parseFloat(response.total).toFixed(2); 
                this.usedEncoding = this.OriginalEncodingUsage;  
                this.unitAutoChange();
            } else {
                this.usedEncoding = "0.00";
                this.totalEncodingValue = 0;
            }     
        },
        calculatePercentage() {
            
            let baseEncoding = parseFloat(this.totalEncodingUnit);
            let usedEncoding = parseFloat(this.usedEncoding);

            // if(this.encodingUnit === 'MB'){
            //     baseEncoding = baseEncoding * 1000;
            // } else if(this.encodingUnit === 'TB'){
            //     baseEncoding = baseEncoding / 1000;
            // } else if(this.encodingUnit === 'GB'){
            //     baseEncoding = baseEncoding;
            // }

            // console.log('base', baseEncoding);
            // console.log('usedEncoding', usedEncoding);
            this.totalEncodingValue = ((usedEncoding / baseEncoding) * 100).toFixed(1);
            //console.log('this.totalTrafficValue', this.totalEncodingValue);
        },
        unitAutoChange() {
            //const usedEncodingInBytes = this.OriginalEncodingUsage;   //   730032
            let usedEncoding = this.OriginalEncodingUsage;            //   730032
            //let usedEncoding = usedEncodingInBytes / (1000 * 1000);  //   0.730032
            let unit = this.encodingUnit;
            // console.log("unit ===> ", unit)
            //  console.log("usedEncoding ===> ", usedEncoding)

            //유저
            if (this.reference && this.reference.rp_unit) {
                switch (this.reference.rp_unit) {
                    case 'TB':
                        usedEncoding /= (1024 * 1024 * 1024 * 1024);
                        break;
                    case 'GB':
                        usedEncoding /= (1024 * 1024 * 1024);
                        break;
                    case 'MB':
                        usedEncoding /= (1024 * 1024);
                }
                this.encodingUnit = this.reference.rp_unit;
            } else {
                // if (usedEncoding > 1000 * 1000 * 1000) {
                //     this.encodingUnit = 'TB';
                //     usedEncoding /= (1000 * 1000 * 1000);
                // } else if (usedEncoding > 1000 * 1000) {
                //     this.encodingUnit = 'GB';
                //     usedEncoding /= (1000 *1000);
                // } else if (usedEncoding > 1000) {
                //     this.encodingUnit = 'MB';
                //     usedEncoding /= 1000;
                // }
                // 기본값 -> bytes
                switch (unit) {
                    case 'MB':
                        usedEncoding /= 1024 ** 2;
                        break;
                    case 'GB':
                        usedEncoding /= 1024 ** 3;
                        break;
                    case 'TB':
                        usedEncoding /= 1024 ** 4;
                        break;
                }

            }
            usedEncoding = Math.round(usedEncoding * 100) / 100;
            this.usedEncoding = usedEncoding.toFixed(2);
            this.calculatePercentage();
        },
        changeEncodingUnit(units) {
            this.encodingUnit = units === 'M' ? 'MB' : units === 'G' ? 'GB' : 'TB';
            let usedMB = this.OriginalEncodingUsage / (1024 * 1024);
            switch (units) {
                case 'G': this.usedEncoding = (usedMB / 1024).toFixed(2); break;
                case 'T': this.usedEncoding = (usedMB / (1024 * 1024)).toFixed(2); break;
                default: this.usedEncoding = usedMB.toFixed(2);
            }
            this.calculatePercentage();
        },
        formatDate(date) {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const hh = String(date.getHours()).padStart(2, '0');
            const min = String(date.getMinutes()).padStart(2, '0');
            const ss = String(date.getSeconds()).padStart(2, '0');

            return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
        },
    },
    watch: {
        'reference': {
            deep: true,
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal && newVal.rp_unit) {
                    this.encodingUnit = newVal.rp_unit;
                } else {
                    this.encodingUnit = 'GB';
                }

                if (newVal && newVal.rp_traffic) {
                    this.totalEncoding = newVal.rp_encoding;
                } else {
                    this.totalEncoding = 1000;
                }
                //this.unitAutoChange();
                this.getEncodingUsageData();
            }
        },
        'formattedDate' : {
            deep: true,
            immediate: true,
            handler(newVal) {
                // console.log("new => ", newVal)
                this.usedEncoding = null;
                this.totalEncodingValue = null;
                this.getEncodingUsageData();
            }
        }

    },
    computed: {
        totalEncodingUnit(){
            let val = 0;
            if(this.encodingUnit === 'MB'){
                val = this.totalEncoding * 1024;
            } else if(this.encodingUnit === 'TB'){
                val = this.totalEncoding / 1024;
            } else if(this.encodingUnit === 'GB'){
                val = this.totalEncoding;
            }
            return val;
        }
    }
};
</script>

<style scoped>
.statistics_sub {
    color: #999;
    font-size: 14px;
}

h4 strong {
    color: #006cea;
}

.loading-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #ccc;
  border-top-color: #999;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

</style>